var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextNumberedList = function SvgTextNumberedList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M4.167 8.334V3.963c-.564.138-.994.526-1.25 1.037m2.917 10.834H3.007v-.417c.735-.515 1.488-1.001 2.091-1.676.402-.45.447-1.126.013-1.579-.352-.368-.961-.488-1.43-.306-.318.124-.499.37-.674.644M17.5 5H9.167m8.333 5H9.167m8.333 5H9.167"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextNumberedList);
export default ForwardRef;